// extracted by extract-css-chunks-webpack-plugin
module.exports = {"contextMenu":"contextMenu-2c7ye","popup":"popup-2hwx2","group":"group-1tiqp","quickbar":"quickbar-12hiP","labelHeader":"labelHeader-3asxd"};